import React from "react";
import { ORDERS_COLOR, getMetadataColor } from "../../utils/metadataColors";

/**
 * Chip row for filtering a reports list.
 *
 * Plain inline styles on purpose: this is shared between a Chakra surface
 * (ResultsTable) and a Tailwind surface (MedStudent), and Tailwind utilities only
 * apply inside #clinic-root in this app.
 */
const chipColor = (key) => {
  if (key === "Orders") return ORDERS_COLOR;
  if (key === "All") return "#2D3748";
  if (key === "Unclassified" || key === "OCR Failed") return "#718096";
  return getMetadataColor(key);
};

export default function ReportsFilterBar({ filters, counts, activeFilter, onSelect }) {
  return (
    <div
      role="group"
      aria-label="Filter reports by category"
      style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "12px" }}
    >
      {filters.map(({ key, label }) => {
        const isActive = key === activeFilter;
        const color = chipColor(key);
        return (
          <button
            key={key}
            type="button"
            aria-pressed={isActive}
            onClick={(e) => {
              e.stopPropagation();
              onSelect(key);
            }}
            style={{
              fontSize: "11px",
              fontWeight: isActive ? 700 : 500,
              padding: "3px 10px",
              borderRadius: "999px",
              cursor: "pointer",
              whiteSpace: "nowrap",
              border: `1px solid ${color}`,
              color: isActive ? "#fff" : color,
              backgroundColor: isActive ? color : "transparent",
            }}
          >
            {label} ({counts?.[key] ?? 0})
          </button>
        );
      })}
    </div>
  );
}
